export const profileGetMiscellaneousIdsList = profile => {
  profile.accepted_documents =
    profile.accepted_documents.map((e) => e.id);
  profile.preferred = profile.preferred.map(
    (e) => e.item_id
  );
  profile.owned = profile.owned.map((e) => e.item_id);

  profile.preferred_games = profile.preferred_games.map(
    (e) => e.item_id
  );
  profile.owned_games = profile.owned_games.map(
    (e) => e.item_id
  );
  return profile
}